exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3gGlBxj4mqtEN8UCmqFx06 {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n._3vzw8zSjZ44yBXmgvIyVOH {\n  text-align: center;\n  color: var(--secondary-text-color);\n  font-size: var(--font-size-normal);\n  margin: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"toolsGrid": "_3gGlBxj4mqtEN8UCmqFx06",
	"emptyMessage": "_3vzw8zSjZ44yBXmgvIyVOH"
};